import Alpine from 'alpinejs';
import axios from 'axios';

Alpine.data('chat', () => chatData);

/**
 * @type {{
 *      loaded: boolean,
 *      init(): void,
 *      endpoint: string,
 *      $nextTick: (function(*=): Promise<unknown>),
 *      $refs: Proxy,
 *      messages: object[],
 *      loadNewMessages: ((function(): Promise<void>)|*),
 *      loadMessages: ((function(): Promise<void>)|*)
 * }}
 */
const chatData = {
    loaded: true,
    endpoint: '/chat/messages',
    messages: [],
    init() {
        this.loadMessages();
        this.loaded = false;

        document.addEventListener('chat.scroll', () => {
            this.$nextTick(() => {
                this.scroll();
                setTimeout(() => {
                    this.loaded = true;
                }, 200);
            });
        });

        document.addEventListener('chat.added', () => {
            this.loadNewMessages();
        })

        document.addEventListener('chat.close', () => {
            this.loaded = false;
        });
    },
    scroll() {
        this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight;
    },
    loadMessages: async function() {
        if (!this.loaded || !this.endpoint) {
            return;
        }

        const { data: { data = [], nextPageUrl } } = await axios.get(this.endpoint);

        if (this.messages.length > 0) {
            const messageID = this.messages[0].id;
            this.$nextTick(() => {
                const block = this.$refs.messages.querySelector(`[data-message="${messageID}"]`);
                this.$refs.messages.scrollTop = block.offsetTop;
            });
        }

        this.messages.forEach(message => data.push(message));
        this.messages = data;
        this.endpoint = nextPageUrl;
    },
    loadNewMessages: async function() {
        const params = {};

        if (this.messages.length > 0) {
            params.id = this.messages[this.messages.length-1].id;
            params.created_at = this.messages[this.messages.length-1].created_at;
        }

        const { data: { data = [] } } = await axios.get('/chat/poll', { params });

        if (this.$refs.messages.scrollTop >= this.$refs.messages.scrollHeight - this.$refs.messages.clientHeight - 30) {
            this.$nextTick(() => {
                this.scroll();
            })
        }

        this.messages.push(...data);
    },
};
